import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getAllWallet = async ({
  pageNumber,
  size,
  consumerType,
  aggregatorId,
}) => {
  let queryParams = `Page=${pageNumber}&PageSize=${size}`;

  if (consumerType) {
    queryParams = `${queryParams}&ConsumerType=${consumerType}`;
  }
  if (aggregatorId) {
    queryParams = `${queryParams}&TargetId=${aggregatorId}`;
  }
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.GET_ALL_WALLET}?${queryParams}`
  );

  return data;
};

export default function useAllWallet({
  pageNumber,
  size,
  consumerType,
  aggregatorId,
}) {
  return useQuery(
    [{ pageNumber, size, consumerType, aggregatorId }, "getAllWallet"],
    getAllWallet
  );
}
